import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import {
  analyticsCtaDataObject,
  handleAdobeNavEvent,
} from '../../../helpers/adobe-analytics';

export class George extends Lit3formBlock {
  static get characterName() {
    return 'george';
  }

  static get characterProperties() {
    return {
      cta: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid george-layout">
          ${this.headerHTML}
          <div class="card-groups">
            ${this.cardGroups.map(cardGroup => this.driversHTML(cardGroup))}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  firstUpdated() {
    this._onResize = () => this.updateRowBorders();
    window.addEventListener('resize', this._onResize);
    // Run once after initial render
    this.updateComplete?.then?.(() => this.updateRowBorders());
  }

  updated() {
    this.updateRowBorders();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
    super.disconnectedCallback?.();
  }

  updateRowBorders() {
    const grids = this.renderRoot?.querySelectorAll?.('.card-group-drivers');
    if (!grids) return;
    grids.forEach(grid => {
      const drivers = Array.from(grid.children).filter(
        el => el && el.nodeType === 1
      );

      drivers.forEach(el => el.classList.remove('is-last-row'));
      if (drivers.length === 0) return;

      const lastRowTop = Math.max(...drivers.map(el => el.offsetTop));

      drivers.forEach(el => {
        if (el.offsetTop === lastRowTop) el.classList.add('is-last-row');
      });
    });
  }

  driversHTML(cardGroup) {
    return html`
      <div class="card-group-wrapper">
        <h3 class="card-group-header">
          ${cardGroup.heading}
        </h3>
        <div class="card-group-drivers">
          ${cardGroup.driver_cards.map(driverCard =>
            this.driverInternalHtml(driverCard)
          )}
        </div>
      </div>
    `;
  }

  driverInternalHtml(driver) {
    return !!driver.text_sections
      ? html`
          <span class="driver-wrapper">
            <a
              class="image"
              href=${driver.url}
              @click="${event => {
                handleAdobeNavEvent({
                  navString: `NAV|Hardware Compare|${driver.title}`,
                  destinationUrl: driver.url,
                  event,
                });
              }}"
            >
              <img src=${this.imageUrl(driver.image)} />
            </a>
            <h3 class="image-title">
              ${unsafeHTML(this.withLineBreaks(driver.title))}
            </h3>
            <p class="image-description">
              ${unsafeHTML(this.withLineBreaks(driver.description))}
            </p>
            ${this.textSectionsHTML(driver)}
            <cta-button
              cta-type="secondary"
              cta-data=${this.imageCtaData(driver)}
              .ctaAnalyticsData=${analyticsCtaDataObject(
                driver,
                this.headerText
              )}
            ></cta-button>
          </span>
        `
      : html`
          <span class="driver-wrapper">
            <div class="image">
              <img src=${this.imageUrl(driver.image)} />
            </div>
          </span>
        `;
  }

  textSectionsHTML(image) {
    return image.text_sections?.length > 0
      ? html`
          <div class="text-sections-wrapper">
            ${image.text_sections.map(section => {
              return html`
                <span class="text-section">
                  <p class="text-section-header">
                    ${unsafeHTML(this.withLineBreaks(section.heading))}
                  </p>
                  <p class="text-section-body">
                    ${section.paragraphs.map(paragraph => {
                      const text = paragraph?.text || '';
                      return unsafeHTML(this.withLineBreaks(text));
                    })}
                  </p>
                </span>
              `;
            })}
          </div>
        `
      : html``;
  }

  imageUrl(image) {
    return this.imagebossUrl(image.src, 350);
  }

  imageCtaData(image) {
    let cta = {};
    if (image) {
      cta.text = image.text;
      cta.url = image.url;
      cta.fullWidth = true;
    }
    return JSON.stringify(cta);
  }

  get cardGroups() {
    return !this.content.card_groups || this.content.card_groups.length === 0
      ? []
      : this.content.card_groups;
  }

  get headerHTML() {
    return this.headerText
      ? html`
          <div class="header">
            <h2>${unsafeHTML(this.headerText)}</h2>
            ${this.descriptionHTML}
          </div>
          <div class="header-rule"></div>
        `
      : ``;
  }

  get descriptionHTML() {
    return this.descriptionText
      ? html`
          <p class="description">
            ${unsafeHTML(this.descriptionText)}
          </p>
        `
      : ``;
  }
}
George.defineElement();
